import React, { useEffect, useRef, useState } from 'react';
import { Item, OwnerItem } from '@/types/item';
import { toastify } from '@/utils/toastify';
import { t } from 'i18next';
import { ITEMS_CONST } from '@/configs/constants';

interface ListProps {
    className?: string,
    items: OwnerItem[],
    onChangeSelect: (selectedItems) => void,
    onEndReached?: () => Promise<void>,
    isLoading: boolean
}

const CardList: React.FC<ListProps> = ({ className = '', items, onChangeSelect = () => { }, onEndReached, isLoading }) => {
    let listSelecting: number[] = [];
    const [listSelecting2, setListSelecting2] = useState<number[]>([]);

    const sentinelRef = useRef<HTMLDivElement>(null);
    const isFetching = useRef(false); // Trạng thái kiểm soát việc gọi

    useEffect(() => {
        listSelecting = [];
    }, []);

    useEffect(() => {
        if (!onEndReached || !sentinelRef.current || isLoading) return;

        const observer = new IntersectionObserver(
            async ([entry]) => {
                if (entry.isIntersecting && !isFetching.current) {
                    isFetching.current = true; // Đánh dấu đang tải dữ liệu
                    await onEndReached(); // Gọi API
                    setTimeout(() => (isFetching.current = false), 1000); // Đợi 1 giây trước khi cho phép gọi tiếp
                }
            },
            { rootMargin: '100px' }
        );

        observer.observe(sentinelRef.current);

        return () => observer.disconnect();
    }, [onEndReached]);

    return (
        <div className={`grid grid-cols-2 content-start ${className}`}>
            {items.map((item, index) => (
                <div
                    key={item.id}
                    onClick={() => {
                        if (listSelecting2.includes(item.id)) {
                            setListSelecting2(prev => prev.filter(id => id !== item.id));
                            listSelecting = listSelecting2.filter(id => id !== item.id);
                            onChangeSelect(listSelecting);
                        } else if (listSelecting2.length === 5) {
                            toastify('error', t('text.maxSelect', { max: 5 }));
                            return;
                        } else {
                            const list = [...listSelecting2, item.id];
                            listSelecting = list;
                            setListSelecting2(prev => [...prev, item.id]);
                            onChangeSelect(list);
                        }
                    }}
                    className={`relative rounded-[4px] shadow-sm hover:shadow-md p-[12px] transition bg-white flex flex-col items-centerZ ${listSelecting2.includes(item.id) ? 'border-greenMain border-[3px]' : 'border-white border-[3px]'}
                `}
                >
                    <img
                        loading='lazy'
                        src={item.file?.path}
                        alt={item.file?.filename}
                        className='w-full  h-[40vw] rounded-[4px] object-cover'
                    />

                    {item.itemType === ITEMS_CONST.ITEM_TYPE.COUPON && (
                        <div className='absolute top-[12px] right-[12px] bg-gradient-to-r from-[#EA4335] to-[#F47843] text-white text-xs px-[12px] py-[2px] rounded-bl-sm rounded-tr-sm'>
                            {t('text.coupon')}
                        </div>
                    )}
                    <div className='pt-[16px] text-left text-sm font-semibold overflow-hidden truncate'>{item.item}</div>
                </div>
            ))}
            <div ref={sentinelRef} className='h-4'></div>
        </div>
    );
};

export default CardList;
